import { GenericPage } from "../../../../../pages";
import { clientRoute } from "./resources-client.route";

export const resourcesRoute = [
  {
    path: "clients",
    element: <GenericPage />,
    children: clientRoute,
  },
];
